module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("vpn_key")]), _vm._v(" Regenerar token\r\n    "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 4)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('h5', [_c('strong', [_vm._v("Trámite: ")]), _vm._v(_vm._s(_vm.doc.documento.nombre))]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\r\n      Se regenerará el Token del trámite para que pueda realizar pagos en la "), _c('strong', [_vm._v("Plataforma de pagos")]), _vm._v(".\r\n    ")]), _vm._v(" "), (_vm.showUsuariosApp) ? _c('div', [(_vm.doc.usuariosApp.length > 1) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\r\n        Seleccione una Aplicación que esté asociada al trámite que quiere crear, de la misma forma en que lo hace en la Plataforma de Pagos\r\n      ")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.doc.usuariosApp,
      "label": "Aplicación en la Plataforma de pago",
      "item-text": "endpoint",
      "item-value": "id_usuario_app",
      "readonly": _vm.doc.usuariosApp.length == 1,
      "autocomplete": "",
      "noDataText": "No hay resultados"
    },
    model: {
      value: (_vm.usuarioapp),
      callback: function($$v) {
        _vm.usuarioapp = $$v
      },
      expression: "usuarioapp"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showUsuariosApp && _vm.documento) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": true
    }
  }, [_vm._v("\r\n      El documento seleccionado no tiene asociado ninguna Aplicación en la Plataforma de Pagos\r\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 4)
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" Cancelar\r\n    ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.show || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.obtainTokenForDocument()
      }
    }
  }, [_c('v-icon', [_vm._v("check_circle")]), _vm._v(" Regenerar token\r\n    ")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e45eb55","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eApostilla/documento/Regenerar.vue
// module id = 500
// module chunks = 2